// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_2peMO","user-details":"_3xGlv","memberIcon":"_2ZFCB","overlay":"yRE5f","lists":"_2wRYb"};